const StoreName = {
    ASSET: 'asset',
    CONCURRENCY: 'concurrency',
    CONFIG: 'config',
    CONVIVA: 'confiva',
    PLAYBACK: 'playback',
    PRECISION: 'precision',
    RESUME_POINTS: 'resumePoints',
    USER_ACTIONS: 'userActions',
};

export default StoreName;
